import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsOfflineExporting from 'highcharts/modules/offline-exporting'
import highchartsAccessibility from 'highcharts/modules/accessibility'
import NoDataImage from '../../../../common/components/NoDataImage'

HighchartsExporting(Highcharts)
HighchartsOfflineExporting(Highcharts)
highchartsAccessibility(Highcharts)

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Open Sans", sansSerif',
    },
  },
})

const StackedBarChart = ({
  chartRef,
  chartType,
  chartOptions,
  chartKey = '',
  noDataImageURL,
  showEmbed,
  handleOpenChartEmbed,
}) => {
  const { series } = chartOptions
  const noData =
    series?.length === 0 || series?.every((item) => item?.data?.length === 0)

  const existingMenuItems =
    chartOptions?.exporting?.buttons?.contextButton?.menuItems || []
  const menuItems = showEmbed
    ? existingMenuItems.includes('openEmbedPopup')
      ? existingMenuItems
      : [...existingMenuItems, 'openEmbedPopup']
    : existingMenuItems

  const mergedChartOptions = {
    ...chartOptions,
    exporting: {
      ...chartOptions?.exporting,
      buttons: {
        ...chartOptions?.exporting?.buttons,
        contextButton: {
          ...chartOptions?.exporting?.buttons?.contextButton,
          menuItems,
        },
      },
      menuItemDefinitions: {
        ...chartOptions?.exporting?.menuItemDefinitions,
        openEmbedPopup: showEmbed
          ? {
              text: 'Embed',
              onclick: () => handleOpenChartEmbed(),
            }
          : {},
      },
    },
  }

  return (
    <div className="tui__chart_content">
      {!noData ? (
        <figure className="highcharts-figure barchart-figure">
          <HighchartsReact
            ref={chartRef}
            key={`highcharts-${chartKey}-${JSON.stringify(chartOptions)}`}
            highcharts={Highcharts}
            options={mergedChartOptions}
          />
        </figure>
      ) : (
        <NoDataImage imageURL={noDataImageURL} height="345px" width="100%" />
      )}
    </div>
  )
}
export default StackedBarChart
